import React from "react";
import { Helmet } from "react-helmet-async";
import RefrigeratedTruckHero from "../components/refrigerated-truck/RefrigeratedTruckHero";
import RefrigeratedTruckAboutUs from "../components/refrigerated-truck/RefrigeratedTruckAboutUs";
import RefrigeratedTruckPlans from "../components/refrigerated-truck/RefrigeratedTruckPlans";

import RefrigeratedTruckCards from "../components/refrigerated-truck/RefrigeratedTruckCards";
import CtaTransportSection from "../components/global/CtaTransportSection";
import ClientSatisfactionHero from "../components/global/ClientSatisfaction";
import RefrigeratedTruckIndustries from "../components/refrigerated-truck/RefrigeratedTruckIndustries";
import RefrigeratedTruckServices from "../components/refrigerated-truck/RefrigeratedTruckServices";
import WhyChooseTruck from "../components/chiller-truck/IndustrialChillerTruck";

const RefrigeratedTruck = () => {
  return (
    <>
      <Helmet>
        <title>Refrigerated Truck Rental Dubai | Chiller &amp; Freezer Transport UAE | Chiller Fleet</title>
        <meta name="description" content="Rent refrigerated trucks in Dubai with Chiller Fleet. 24/7 cold chain transport solutions for food, pharmaceuticals, and other temperature-sensitive goods across UAE." />
        <meta property="og:title" content="Refrigerated Truck Rental Dubai | Chiller & Freezer Transport UAE | Chiller Fleet" />
        <meta property="og:description" content="Rent refrigerated trucks in Dubai with Chiller Fleet. 24/7 cold chain transport solutions for food, pharmaceuticals, and other temperature-sensitive goods across UAE." />
        <meta property="og:url" content="https://chillerfleet.com/services/refrigerated-trucks" />
        <meta name="twitter:title" content="Refrigerated Truck Rental Dubai | Chiller & Freezer Transport UAE | Chiller Fleet" />
        <meta name="twitter:description" content="Rent refrigerated trucks in Dubai with Chiller Fleet. 24/7 cold chain transport solutions for food, pharmaceuticals, and other temperature-sensitive goods across UAE." />
      </Helmet>

      <RefrigeratedTruckHero />

      <RefrigeratedTruckAboutUs />
      <RefrigeratedTruckIndustries />

      <RefrigeratedTruckServices />
      <WhyChooseTruck />
      {/* <AltajServiceSlider /> */}
      <ChillerFleetServiceSliderContentSimple />

      <CtaTransportSection />
      <ClientSatisfactionHero />
    </>
  );
};

export default RefrigeratedTruck;
